import React from 'react';
import PropTypes from 'prop-types';

/**
 * OnboardingWelcome - Screen 1 of chapters onboarding
 *
 * Emotional warmth screen, no form fields.
 * Sets the tone for the memoir experience.
 */
function OnboardingWelcome({ userName, onNext }) {
  return (
    <div className="min-h-screen bg-fb-cream flex items-center justify-center p-6">
      <div className="max-w-lg w-full text-center">
        {/* Book emoji */}
        <div className="text-6xl mb-8">📖</div>

        {/* Welcome message */}
        <h1 className="font-serif text-3xl font-bold text-gray-900 mb-4">
          Welcome, {userName}.
        </h1>

        <div className="space-y-4 mb-10">
          <p className="font-serif text-lg text-gray-700 leading-relaxed">
            Your family gave you this gift because your story matters to them.
          </p>
          <p className="font-serif text-lg text-gray-700 leading-relaxed">
            We're going to help you write the story of your life — in your own words, at your own pace.
          </p>
          <p className="font-serif text-base text-gray-500 italic">
            It only takes a minute to get started.
          </p>
        </div>

        {/* CTA Button */}
        <button
          onClick={onNext}
          className="
            bg-fb-olive hover:bg-fb-olive/90 text-white
            font-bold text-lg py-4 px-12
            rounded-xl shadow-md
            transition-all duration-200
            focus:outline-none focus:ring-2 focus:ring-fb-olive focus:ring-offset-2
          "
        >
          Let's Begin →
        </button>
      </div>
    </div>
  );
}

OnboardingWelcome.propTypes = {
  userName: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default OnboardingWelcome;
